<div class="d-flex p-4 justify-content-between">
  <div>
    <div class="header">
      <h4 class="text-bold">Service Scope</h4>
      <small *ngIf="!regionScoping||regionScoping.length===0"
             class="pb-2 form-text text-muted">This section allows you to specify regions in which this service in
        available
        and the.<span class="text-primary-dark"> If no scope is specified, this service will be available every where
          and
          at the same price.</span>
      </small>
      <a class="btn btn-outline-primary btn-sm"
         *hasPermission="['services:edit_service_scoping']"
         routerLink="add-region">
        <ezy-icons src="/assets/icons/plus-primary.svg"
                   class="text-outline-primary"></ezy-icons>
        Add a Region
      </a>
      <div class="pt-2"
           *ngIf="regionScoping.length>0">
        <small>
          <span class="text-success">
            <ezy-icons src="/assets/icons/exclamation-circle.svg"></ezy-icons>
          </span>
          <span class="text-primary-dark">This service is only available in these regions</span>
        </small>
      </div>
    </div>
    <div class="regions-table" *ngIf="regionScoping.length>0">
      <table class="table table-sm">
        <thead>
          <tr class="text-primary-dark">
            <th>#</th>
            <th>Country</th>
            <th>Places</th>
            <!-- <th>Last Updated</th> -->
            <!-- <th>Published</th> -->
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let region of regionScoping;let i=index">
            <td>{{i+1}}</td>
            <td>{{region.region}}</td>
            <td>{{region.districts.length}}</td>
            <!-- <td>{{region.districts.length}}</td> -->
            <!-- <td>
              <div class="custom-control custom-switch">
                <input type="checkbox"
                       class="custom-control-input"
                       id="customSwitch-{{i}}">
                <label class="custom-control-label"
                       for="customSwitch-{{i}}"></label>
              </div>
            </td> -->
            <td>
              <a class="text-primary text-decoration-underline mr-2"
                 *hasPermission="['services:view_service_scoping']"
                 [routerLink]="i">
                View/Edit
              </a>
              <a class="text-danger text-decoration-underline"
              (click)="removeRegion(i)"
                 *hasPermission="['services:edit_service_scoping']">
                Delete
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div>
    <app-service-action-bar></app-service-action-bar>
  </div>
</div>
<router-outlet></router-outlet>
